const MEDIA_PREFIXES = ["image/", "video/", "audio/"];

const GOOGLE_MEDIA_TYPES = new Set([
  "application/vnd.google-apps.drawing",
  "application/vnd.google-apps.photo",
  "application/vnd.google-apps.video",
  "application/vnd.google-apps.folder",
]);

/** Returns true for PDFs, docs, spreadsheets, presentations, and text/code files. Skips media. */
export function isTextBasedDocument(mimeType: string, fileName?: string): boolean {
  if (!mimeType) return false;
  if (GOOGLE_MEDIA_TYPES.has(mimeType)) return false;
  if (MEDIA_PREFIXES.some((p) => mimeType.startsWith(p))) return false;

  if (
    mimeType === "application/vnd.google-apps.document" ||
    mimeType === "application/vnd.google-apps.spreadsheet" ||
    mimeType === "application/vnd.google-apps.presentation"
  ) {
    return true;
  }

  if (mimeType === "application/pdf") return true;
  if (mimeType.startsWith("text/")) return true;

  if (
    mimeType === "application/msword" ||
    mimeType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
    mimeType === "application/vnd.ms-excel" ||
    mimeType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    mimeType === "application/vnd.ms-powerpoint" ||
    mimeType === "application/vnd.openxmlformats-officedocument.presentationml.presentation"
  ) {
    return true;
  }

  if (
    mimeType === "application/vnd.oasis.opendocument.text" ||
    mimeType === "application/vnd.oasis.opendocument.spreadsheet" ||
    mimeType === "application/vnd.oasis.opendocument.presentation"
  ) {
    return true;
  }

  if (
    mimeType === "application/json" ||
    mimeType === "application/xml" ||
    mimeType === "text/xml" ||
    mimeType === "text/csv"
  ) {
    return true;
  }

  if (fileName) {
    const ext = fileName.toLowerCase().split(".").pop() || "";
    const textExtensions = [
      "pdf", "doc", "docx", "txt", "md", "markdown",
      "xls", "xlsx", "csv", "ppt", "pptx",
      "odt", "ods", "odp", "rtf",
      "json", "xml", "html", "htm", "css",
      "js", "ts", "jsx", "tsx", "py", "java",
      "c", "cpp", "h", "hpp", "log",
    ];
    if (textExtensions.includes(ext)) return true;
  }

  return false;
}
